const infoNavigation = [
  {
    id: 'news-feed',
    router: true,
    route: 'news-feed.en-IE',
  },
  {
    id: 'internationalNetwork',
    href: 'https://fashionunited.info/network-and-social-media',
    router: true,
    route: 'landing',
    params: { landingPrefix: 'network-and-social-media' },
    items: [],
  },
  {
    id: 'about',
    href: 'https://fashionunited.info/about-us',
    router: true,
    route: 'landing',
    params: { landingPrefix: 'about-us' },
    items: [
      {
        id: 'info.about',
        href: 'https://fashionunited.info/about-us',
        router: true,
        route: 'landing',
        params: { landingPrefix: 'about-us' },
      },
      {
        id: 'info.about.mediaReleases',
        router: true,
        route: 'category',
        params: {
          categoryPath: 'news/business',
        },
      },
    ],
  },
  {
    id: 'careers',
    href: 'https://fashionunited.info/careers',
    router: true,
    route: 'landing',
    params: {
      landingPrefix: 'landing',
      path: 'careers',
    },
    items: [],
  },
  {
    id: 'contact',
    href: 'https://fashionunited.info/contact',
    router: true,
    route: 'landing',
    params: { landingPrefix: 'contact' },
    items: [],
  },
  {
    id: 'conditions',
    href: 'https://fashionunited.info/conditions',
    router: true,
    route: 'landing',
    params: { landingPrefix: 'conditions' },
    items: [
      {
        id: 'info.conditions',
        href: 'https://fashionunited.info/conditions',
        router: true,
        route: 'landing',
        params: { landingPrefix: 'conditions' },
      },
      {
        id: 'info.conditions.termsOfUse',
        href: 'https://fashionunited.info/terms-of-use',
        router: true,
        route: 'landing',
        params: { landingPrefix: 'terms-of-use' },
      },
    ],
  },
];

const getNavigation = (newsboard, locale, jobsLanding, lite, hasNews) => (
  newsboard === 'FASHIONUNITED_INFO' ? infoNavigation : [
    {
      id: 'news-feed',
      router: !lite,
      route: `news-feed.${locale}`,
      href: 'https://fashionunited.com/just-in',
    },
    {
      id: 'news',
      router: hasNews || lite,
      route: 'index',
      href: '/',
    },
    {
      id: 'jobs',
      href: '/fashionjobs',
      router: jobsLanding,
      route: `jobs-landing.${locale}`,
    },
    {
      id: 'marketplace',
      href: 'https://fashionunited.com/marketplace',
      router: newsboard === 'FASHIONUNITED_COM',
      route: 'landing',
      params: { landingPrefix: 'marketplace' },
    },
    {
      id: 'lookbook',
      href: 'https://fashionunited.com/lookbook',
      router: newsboard === 'FASHIONUNITED_COM',
      route: 'lookbook',
    },
    {
      id: 'events',
      router: true,
      route: 'events',
    },
    {
      id: 'data',
      href: 'https://fashionunited.com/i',
      router: newsboard === 'FASHIONUNITED_COM',
      route: 'landing',
      params: { landingPrefix: 'i' },
    },
    {
      id: 'trends',
      router: true,
      route: 'trends',
    },
  ]
);

export {
  getNavigation as default,
  infoNavigation,
};
